<div class="container single-view" id="dashboard">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 class="section-title">{{ 'DASHBOARD.TITLE' | translate }}</h1>
        </div>
        @if (dashboardTotalCount) {
          <div class="flex items-end justify-between gap-3">
            <form novalidate [formGroup]="dashboardFormGroup" id="dashboard-selector">
              @if (dashboardRead) {
                <app-custom-dropdown
                  data-testid="dashboard-dropdown"
                  class="dashboards-dropdown"
                  [compactUi]="true"
                  [placeholder]="placeholder"
                  [options]="dashboards"
                  optionLabel="name"
                  optionValue="metabaseId"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showClear]="false"
                  [showSearchbox]="false"
                  [searchMode]="'local'"
                  [pageSize]="dashboardRowsPerPageOption"
                  formControlName="_dashboard">
                </app-custom-dropdown>
              }
            </form>
          </div>
        }
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      @if (dashboardRead) {
        <div class="view-content-wr">
          @if (dashboardTotalCount) {
            <div class="row">
              <div class="flex flex-col col-12">
                <div id="dashboard-container">
                  @if (selectedDashboardUrl) {
                    <iframe [src]="selectedDashboardUrl | safe:'resourceUrl'" width="100%" height="100%">
                    </iframe>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="flex flex-col col-12">
              <p>{{ 'DASHBOARD.NO_DATA' | translate }}</p>
            </div>
          }
        </div>
      } @else {
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <p>{{ 'DASHBOARD.GREETING' | translate }}, {{ session.user?.username }}</p>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
